export default (string: string) => {
	return string ? string.split(';').map(x=>x.trim()).filter(x=>x) : [];
};